import { api } from 'data/api/api'

import {
  GetRoktTransactionAttributesArgs,
  GetRoktTransactionAttributesResp,
} from '../types/rokt-transaction-attributes'
import { PostAdvertisingLeadFormArgs } from '../types/advertising-lead-form'
import { postAdvertisingLeadFormArgsToParams } from '../transformers/advertising-lead-form'
import {
  GetAdEligibilityForTransactionResp,
  GetVanAdPlacementArgs,
  GetVanAdPlacementResp,
} from '../types/van-ad-placement'

export const getRoktTransactionsAttributes = ({
  transactionId,
}: GetRoktTransactionAttributesArgs) =>
  api.get<GetRoktTransactionAttributesResp>(
    `/ads/rokt?transaction_id=${transactionId}&cart_items=true`,
  )

export const postAdvertisingLeadForm = (args: PostAdvertisingLeadFormArgs) =>
  api.post('/ads/lead', postAdvertisingLeadFormArgsToParams(args))

export const getVanAdPlacement = ({
  consentStatus,
  page,
  placementId,
  correlationId,
}: GetVanAdPlacementArgs) =>
  api.get<GetVanAdPlacementResp>(`van/${placementId}`, {
    params: {
      screen: page,
      personalize: consentStatus,
    },
    headers: {
      correlation_id: correlationId,
    },
  })

export const getAdEligibilityForTransaction = (transactionId: number) =>
  api.get<GetAdEligibilityForTransactionResp>('ads/offers', {
    params: {
      transaction_id: transactionId,
    },
  })
